<template>
  <v-app>
    <v-container>
      <v-card color="card1">
        <v-card-title>
          Idea List
          <v-spacer></v-spacer>
          <v-btn outlined to="/addvideoidea">
            <v-icon left>mdi-plus</v-icon>
            Add Idea
          </v-btn>
        </v-card-title>
        <v-container>
          <v-expansion-panels hover popout v-for="item in items" :key="item.id" :loading="loading">
            <v-expansion-panel class="my-4">
              <v-expansion-panel-header color="panel">
                <h2>{{ item.type }} - {{ item.name }}</h2>
              </v-expansion-panel-header>
              <v-expansion-panel-content color="panelcontent">
                <div class="my-2">
                  <p>Voting Deadline: {{ item.date }} - {{ item.time }}</p>
                  <p>Description: {{ item.description }}</p>
                  <p v-if="item.rating !== 0">Average Star Rating: {{ item.rating/item.voteCount }} <v-icon class="yellow--text">mdi-star</v-icon>/ 5<v-icon class="yellow--text">mdi-star</v-icon></p>
                  <p v-if="item.video">Idea inspiration:</p>
                  <video-embed
                    v-if="item.video"
                    :src="item.video"
                    :params="{autoplay: 1}"
                    css="embed-responsive-21by9"
                  >
                  </video-embed>
                  <rating-dialog :item="item"></rating-dialog>
                  <delete-vote :idea="item"></delete-vote>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import DeleteVote from '../components/Vote/DeleteVote.vue'
export default {
  components: { DeleteVote },
  title: 'Idea List',
  computed: {
    items () {
      return this.$store.getters.loadedVideoIdeas
    },
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>
